<template lang="html">
  <header class='main-header'>
    <nav class="navbar navbar-collapse navbar-light bg-light">

      <router-link to="/" class="navbar-brand">
        <span class="name">SPORT</span><span class="gray">app</span>
      </router-link>

      <ul class="navbar-nav mx-auto" v-if='currentUser && activeWorkout'>
        <li class="nav-item">
          <router-link :to="{path: '/workout'}" class="nav-link active-order">
            <img :src="activeWorkout.plan.image_url" class="linkPic"/>
          </router-link>
        </li>
      </ul>


      <div class="burger" :class="{on: showCollapse}" @click="toggleCollapse" v-if="currentUser">
        <span></span><span></span><span></span>
      </div>

      <div class="collapse navbar-collapse" :class="{show: showCollapse}" @click="toggleCollapse" v-if="currentUser">

        <div class="row justify-content-center">
          <div :class="subLinkClass">
            <router-link :to="{name: 'workouts'}" class="box parent">
              <i class="icon-accessibility"></i>
              Workouts
            </router-link>
          </div>
          
          <div :class="subLinkClass" v-if="currentUser && activeWorkout">
            <a @click="stopWorkout" class="box parent">
              <i class="icon-warning"></i>
              stop Workout
            </a>
          </div>
          
          <div :class="subLinkClass">
            <router-link :to="{name: 'Settings'}" class="box parent">
              <i class="icon-cogs"></i>
              Setting
            </router-link>
          </div>
          <div :class="subLinkClass">
            <a @click="reloadData" class="box parent">
              <i class="icon-cloud-download"></i>
              Reload
            </a>
          </div>
          
          <div :class="subLinkClass" v-if="3 === 4">
            <router-link to="/" class="box">
              <i class="icon-home"></i>
              Home
            </router-link>
          </div>
          <div :class="subLinkClass" v-if="3 === 4">
            <router-link to="/about" class="box">
              <i class="icon-newspaper"></i>
              About
            </router-link>
          </div>
          
          <div :class="subLinkClass" v-if="!currentUser">
            <router-link to="/login" class="box">
              <i class="icon-enter"></i>
              Login
            </router-link>
          </div>
          
          <div :class="subLinkClass" v-if="currentUser">
            <a class="box sub" @click.stop="logout">
              <i class="icon-enter"></i>
              Logout
            </a>
          </div>
          
        </div>
        

      </div>

    </nav>
  </header>

</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'MainHeader',
  data() {
    return {
      showCollapse: false,
      showDropdown: false,
      subLinkClass: "col-6 col-sm-4 col-md-3 col-lg-2"
    }
  },
  computed: {
    ...mapGetters({
      currentUser:    'currentUser',
      activeWorkout:  'activeWorkout',
      messages:       'getMessages'
    })

  },
  methods: {
    // removeAllMessages(){
    //   this.$store.dispatch('resetMessages')
    // },
    logout(){
      this.showCollapse = false
      this.$router.push('/login')
      localStorage.removeItem('store')
      this.$store.dispatch('logout').then(()=>{
        // this.toggleCollapse()
        // this.toggleDropdown()
        this.showCollapse = false
        this.showDropdown = false
        this.$router.push('/')
      })
    },
    reloadData() {
      this.$store.dispatch('getPlans');
    },
    
    // reload(){
    //   console.log('reload');
    //   this.showCollapse = false
    //   this.$store.dispatch('refreshStore')
    // },
    // reset(){
    //   console.log('reset');
    //   this.showCollapse = false
    //   this.$store.dispatch('resetStore')
    //   // clear indexedDB as well (used for images)
    //   //this.$clearStorage
    //   this.$iterateStorage((value, key, iterationNumber) => {
    //     console.log("Remove DB-Key: " + key);
    //     this.$removeItem(key)
    //   }, (err) => {
    //     if (!err) { console.log('Iteration has completed'); }
    //   })
    //   // this.$store.dispatch('refreshStore')
    //   this.$router.push('/')
    // },
    toggleCollapse() {
      this.showCollapse = !this.showCollapse
    },
    stopWorkout() {
      this.$router.push('/workouts')
      this.$store.dispatch('unsetActiveWorkout')
    }
  }

}
</script>

<style lang="scss">
// @import '@/assets/scss/_colors.scss';



#main-header nav.navbar {
  padding: 5px 10px 5px 0;

  .navbar-brand{
    //width: 125px;
    padding: 0 10px;
    font-family: 'Shadows Into Light', cursive;
    font-weight: bold;
    margin: 0;
    vertical-align: middle;
  }

  .burger {
    position: relative;
    margin: -5px -10px -5px 0;
    height: 60px;
    width: 60px; //height of the whole navigation
    background: transparent;
    cursor: pointer;
    transition-property: background, transform;
    transition-duration: .2s;
    span {
      position: absolute;
      left: 14px;
      right: 14px;
      height: 3px;
      background: #777;
      top: 19px;
      transition-property: background;
      &:nth-child(2) {
        top: 28px;
      }
      &:nth-child(3) {
        top: 37px;
      }
    }
    &.on {
      transform: rotate(90deg);
      background: #999;
      span {
        background: white;
      }
    }
  }

  .navbar-nav {
    li.nav-item {
      padding: 0 1rem;
      a {
        font-size: 1.3em;
        &.router-link-exact-active {
          font-weight: bold;
        }
      }
    }
  }
}

.darkApp #main-header nav.navbar {
  background: #000 !important;
  
  .navbar-brand{
    color: #fff;
    .gray { color: #999; }
  }
  
  .burger {
    span { background: #999; }
    &.on {
      background: #444;
      span {
        background: #000;
      }
    }
  }
  
  .collapse.navbar-collapse {
    background: #444;
    a.box {
      background: #000;
      color: #ccc;
      border-color: #777;
    }
  }
  
  .navbar-nav {
    li.nav-item {
      background: repeating-linear-gradient( -55deg, #000, #000 2px, #333 2px, #333 3px );
      border-radius: 5px;
    }
  }
}


.linkPic { max-height: 30px; }

</style>
